/* Amaji module: assets/amaji-merch-recommendations.js
 * Fetches the Product Recommendations rail and swaps it in. Kept deliberately
 * dependency-free (no import map, no Horizon component base) so it also runs on
 * the cart template. */
class AmajiProductRecommendations extends HTMLElement {
  connectedCallback() {
    const url = this.dataset.url;
    if (!url || this.dataset.loaded) return;
    this.dataset.loaded = 'true';

    fetch(url)
      .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
      .then((text) => {
        const doc = document.createElement('div');
        doc.innerHTML = text;
        const fresh = doc.querySelector('amaji-product-recommendations');
        if (fresh && fresh.innerHTML.trim().length) {
          this.innerHTML = fresh.innerHTML;
          this.closest('.amaji-recs')?.setAttribute('data-populated', 'true');
        }
      })
      .catch(() => {
        /* leave the shell empty - the section simply shows nothing */
      });
  }
}

if (!customElements.get('amaji-product-recommendations')) {
  customElements.define('amaji-product-recommendations', AmajiProductRecommendations);
}
